export const nextToExpress = (context = {}) => {
  const { ctx, router } = context;
  const { req, res } = ctx || {};
  req.get = (headerName) => req.headers[headerName.toLowerCase()];
  res.cookie = (name, value, options = {}) => {
    // Helper function to serialize a cookie
    function serialize(nameLocal, valueLocal, optionsLocal = {}) {
      let cookie = `${encodeURIComponent(nameLocal)}=${encodeURIComponent(valueLocal)}`;

      if (optionsLocal.maxAge) {
        cookie += `; Max-Age=${optionsLocal.maxAge}`;
      }

      if (optionsLocal.domain) {
        cookie += `; Domain=${optionsLocal.domain}`;
      }

      if (optionsLocal.path) {
        cookie += `; Path=${optionsLocal.path}`;
      }

      if (optionsLocal.expires) {
        cookie += `; Expires=${optionsLocal.expires.toUTCString()}`;
      }

      if (optionsLocal.httpOnly) {
        cookie += "; HttpOnly";
      }

      if (optionsLocal.secure) {
        cookie += "; Secure";
      }

      if (optionsLocal.sameSite) {
        cookie += `; SameSite=${optionsLocal.sameSite}`;
      }

      return cookie;
    }

    // Create the new cookie string
    const newCookie = serialize(name, value, {
      sameSite: "strict",
      path: "/",
      ...options,
    });

    // Retrieve any existing Set-Cookie header
    const existingCookies = res.getHeader("Set-Cookie");

    // Prepare the updated Set-Cookie header
    let updatedCookies;
    if (existingCookies) {
      // If there are existing cookies, append the new cookie
      updatedCookies = Array.isArray(existingCookies)
        ? [...existingCookies, newCookie]
        : [existingCookies, newCookie];
    } else {
      // If no existing cookies, just set the new cookie
      updatedCookies = [newCookie];
    }

    // Set the updated Set-Cookie header
    res.setHeader("Set-Cookie", updatedCookies);
  };
  req.query = router.query;
};
